webpackJsonp([35783957827783],{

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/domino-calculator-thumbnail.0a1eef02.png";

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/donut-studio-thumbnail.e81e6821.png";

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/facts-numbers-thumbnail.1c28976f.png";

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/indecision-thumbnail.e1d4f5c1.png";

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/toxic-free-engine-thumbnail.b03a0bfd.png";

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/verbose-barnacle-thumbnail.245ad495.png";

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _verboseBarnacleThumbnail = __webpack_require__(482);
	
	var _verboseBarnacleThumbnail2 = _interopRequireDefault(_verboseBarnacleThumbnail);
	
	var _toxicFreeEngineThumbnail = __webpack_require__(477);
	
	var _toxicFreeEngineThumbnail2 = _interopRequireDefault(_toxicFreeEngineThumbnail);
	
	var _indecisionThumbnail = __webpack_require__(469);
	
	var _indecisionThumbnail2 = _interopRequireDefault(_indecisionThumbnail);
	
	var _factsNumbersThumbnail = __webpack_require__(464);
	
	var _factsNumbersThumbnail2 = _interopRequireDefault(_factsNumbersThumbnail);
	
	var _donutStudioThumbnail = __webpack_require__(460);
	
	var _donutStudioThumbnail2 = _interopRequireDefault(_donutStudioThumbnail);
	
	var _dominoCalculatorThumbnail = __webpack_require__(458);
	
	var _dominoCalculatorThumbnail2 = _interopRequireDefault(_dominoCalculatorThumbnail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'I design & build digital products.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'work' },
	      _react2.default.createElement(
	        'div',
	        { className: 'work__item' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/verbose-barnacle/' },
	          _react2.default.createElement(
	            'div',
	            { className: 'overlay-color' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Verbose Barnacle'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'work__img work__img--short' },
	          _react2.default.createElement('img', { src: _verboseBarnacleThumbnail2.default, alt: 'verbose-barnacle-thumbnail' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'work__item' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/toxic-free-engine/' },
	          _react2.default.createElement(
	            'div',
	            { className: 'overlay-color' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Toxic-free-engine'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'work__img work__img--long' },
	          _react2.default.createElement('img', { src: _toxicFreeEngineThumbnail2.default, alt: 'toxic-free-engine-thumbnail' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'work__item' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/indecision/' },
	          _react2.default.createElement(
	            'div',
	            { className: 'overlay-color' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Indecision'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'work__img work__img--long' },
	          _react2.default.createElement('img', { src: _indecisionThumbnail2.default, alt: 'indecision-thumbnail' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'work__item' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/number-facts/' },
	          _react2.default.createElement(
	            'div',
	            { className: 'overlay-color' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'The interesting fact of numbers'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'work__img work__img--long' },
	          _react2.default.createElement('img', { src: _factsNumbersThumbnail2.default, alt: 'facts-numbers-thumbnail' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'work__item' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/donut-studio/' },
	          _react2.default.createElement(
	            'div',
	            { className: 'overlay-color' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Donut Studio'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'work__img work__img--long' },
	          _react2.default.createElement('img', { src: _donutStudioThumbnail2.default, alt: 'donut-studio-thumbnail' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'work__item' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/domino-calc/' },
	          _react2.default.createElement(
	            'div',
	            { className: 'overlay-color' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Dominoes Calculator'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'work__img work__img--long' },
	          _react2.default.createElement('img', { src: _dominoCalculatorThumbnail2.default, alt: 'dominoes-calculator-thumbnail' })
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-49669eb88865eb5d5c64.js